import { LinkButton } from '@cian/ui-kit';

import { type FC } from 'react';

import { SliderProgressBar } from 'shared/components/SliderProgressBar';

import { type SeriaPlusScheme, type SeriaPlusTabScheme } from '../../settings/seriaPlusTypes';
import { SeriaPlusDescriptions } from '../SeriaPlusDescriptions';

import styles from './SeriaPlusBottomContent.css';

type SeriaPlusBottomContentProps = {
  activeSlideIndex: number;
  activeSlides: SeriaPlusTabScheme['slides'];
  activeTabIndex: number;
  isAutoplayPaused: boolean;
  slideDuration: number;
  tabs: SeriaPlusScheme['tabs'];
  watchObjectsLink?: string;
  onAnimationEnd: () => void;
  onProgressBarHover: () => void;
  onProgressBarLeave: () => void;
  onProgressClick: (slideIndex: number) => void;
};

export const SeriaPlusBottomContent: FC<SeriaPlusBottomContentProps> = props => {
  const {
    activeSlideIndex,
    activeSlides,
    activeTabIndex,
    isAutoplayPaused,
    slideDuration,
    tabs,
    watchObjectsLink,
    onAnimationEnd,
    onProgressBarHover,
    onProgressBarLeave,
    onProgressClick,
  } = props;

  return (
    <div className={styles['bottom-content']}>
      <SeriaPlusDescriptions activeSlideIndex={activeSlideIndex} activeTabIndex={activeTabIndex} tabs={tabs} />

      <div className={styles['cta-column']}>
        {watchObjectsLink && (
          <div className={styles['link-button']}>
            <LinkButton
              data-testid="seria-plus-carousel-link-button"
              href={watchObjectsLink}
              rel="noopener noreferrer"
              size="M"
              target="_blank"
              theme="warning_primary"
            >
              Проекты «Серии плюс»
            </LinkButton>
          </div>
        )}
      </div>

      <div aria-label="Прогресс карусели" className={styles['progress']}>
        <SliderProgressBar
          activeIndex={activeSlideIndex}
          count={activeSlides.length}
          duration={slideDuration}
          paused={isAutoplayPaused}
          onAnimationEnd={onAnimationEnd}
          onDotClick={onProgressClick}
          onProgressBarHover={onProgressBarHover}
          onProgressBarLeave={onProgressBarLeave}
        />
      </div>
    </div>
  );
};
